import { render, staticRenderFns } from "./consultantPortrait.vue?vue&type=template&id=6bb2f086&scoped=true"
import script from "./consultantPortrait.vue?vue&type=script&lang=js"
export * from "./consultantPortrait.vue?vue&type=script&lang=js"
import style0 from "./consultantPortrait.vue?vue&type=style&index=0&id=6bb2f086&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2f086",
  null
  
)

export default component.exports